/* eslint-disable no-extra-boolean-cast */
/* eslint-disable no-else-return */
/* eslint-disable no-lonely-if */
/* eslint-disable consistent-return */
/* eslint-disable import/newline-after-import */
import React, { useState } from 'react';
import { Switch, Route, useLocation } from 'react-router-dom';
import { CSSTransition, SwitchTransition } from 'react-transition-group';
import Header from './components/Header';
import Footer from './components/Footer';
import Dashboard from './pages/Dashboard';
import NewClient from './pages/NewClient';
import NewContract from './pages/NewContract';
import Conciliation from './pages/Conciliation';
import './routes.css';
// eslint-disable-next-line import/order
import cookies from 'react-cookies';
import Details from './components/TableContracts/Details';
import NotFound from './components/PageNotFound';
import NotConnected from './components/NotConnected';
import ScrollToTop from './utils/ScrollToTop';
import { Container } from './styles/global';
import HeaderFull from './components/HeaderFull';
import ReviewContract from './pages/NewContract/ReviewContract';
import Accept from './components/TableContracts/Accept';
import UnioRedirectPopup from './components/UnioRedirectPopup';

function routesDirection(location: any) {
  const cookie = cookies.load('external_tags');
  if (!cookie) {
    return (
      <Switch location={location} key="provider">
        <Route path="*" component={NotConnected} />
      </Switch>
    );
  } else {
    if (!!cookie.gps_recebedor) {
      return (
        <Switch location={location} key="provider">
          <Route exact path="/" component={Dashboard} />
          <Route exact path="/newcontract" component={NewContract} />
          <Route exact path="/details/:id" component={Details} />
          <Route exact path="/accept/:id" component={Accept} />
          <Route exact path="/newcontract/review" component={ReviewContract} />
          <Route exact path="/newclient" component={NewClient} />
          <Route exact path="/conciliation" component={Conciliation} />
          <Route exact path="/notconnected" component={NotConnected} />
          <Route path="*" component={NotFound} />
        </Switch>
      );
      // eslint-disable-next-line no-extra-boolean-cast
    } else if (!!cookie.gps_originador) {
      return (
        <Switch location={location} key="client">
          <Route exact path="/" component={Dashboard} />
          <Route exact path="/newcontract" component={NewContract} />
          <Route exact path="/details/:id" component={Details} />
          <Route exact path="/accept/:id" component={Accept} />
          <Route exact path="/newcontract/review" component={ReviewContract} />
          <Route exact path="/newclient" component={NewClient} />
          <Route exact path="/conciliation" component={Conciliation} />
          <Route exact path="/notconnected" component={NotConnected} />
          <Route path="*" component={NotFound} />
        </Switch>
      );
    }
  }
}

const Routes: React.FC = () => {
  const [isFirstAccess, setIsFirstAccess] = useState(true);
  const location = useLocation();
  return (
    <Container>
      <UnioRedirectPopup show={isFirstAccess} />
      <HeaderFull />
      <Header />
      <SwitchTransition>
        <CSSTransition key={location.key} timeout={100} classNames="fadeSwitch">
          <ScrollToTop>{routesDirection(location)}</ScrollToTop>
        </CSSTransition>
      </SwitchTransition>
      <Footer />
    </Container>
  );
};
export default Routes;
